module.exports = __webpack_public_path__ + "img/word.f9141276.png";